import {
    EVENT_TYPE_IDS,
    EVENT_TYPE_VERSION_ID,
    EVENT_TEMPLATE_IDS,
    TRIGGER_TYPE_NM,
    TRIGGER_OBJECT_NM,
    TRIGGER_SOURCE_NM,
    TRIGGER_LOCATION_NM,
    SEMANTIC_EVENT_NM,
    TOPIC_TAG_TXT,
} from './constant';

export const getEnvelopeBlock = eventName => ({
    event_template_id: EVENT_TEMPLATE_IDS[eventName],
    event_template_version_id: '1',
    event_type_id: EVENT_TYPE_IDS[eventName],
    event_type_version_id: EVENT_TYPE_VERSION_ID[eventName],
    event_client_start_dtm: new Date().toISOString(),
});

export const getClickstreamBlock = (
    eventName,
    triggerSourceKey = null,
    triggerLocationKey = null
) => ({
    trigger_location_nm:
        TRIGGER_LOCATION_NM[eventName]?.[triggerLocationKey] ||
        TRIGGER_LOCATION_NM[eventName]?.[triggerSourceKey] ||
        TRIGGER_LOCATION_NM[eventName] ||
        'search_results',
    trigger_type_nm: TRIGGER_TYPE_NM[eventName],
    trigger_object_nm:
        TRIGGER_OBJECT_NM[eventName]?.[triggerSourceKey] || TRIGGER_OBJECT_NM[eventName],
    trigger_source_nm:
        TRIGGER_SOURCE_NM[eventName]?.[triggerSourceKey] || TRIGGER_SOURCE_NM[eventName],
});

export const getSemanticBlock = eventName => ({
    semantic_event_nm: SEMANTIC_EVENT_NM[eventName],
    topic_tag_txt: TOPIC_TAG_TXT[eventName],
});
